<script>
import vSelect from 'vue-select';
import {mapActions, mapState} from 'vuex';
export default {
    props : ['err','specs','numberFormat','step', 'editable'],
    data : () => ({
        years : [],
        year_id : '',
        brands : [],
        brand_id : '',
        models : [],
        model_id : '',
        versions : [],
        version_id : '',
        conditions : [],
        condition_id : '',
        kilometers : 0,
        exterior_color : '',
        interior_color : '',
        fuelType : '',
        horsePower : '',
        populating: false,
        editData : false,
        body_style: '',
        body_style: '',
        power: '',
        engine: '',
        transmission_type: '',
        fuel_type: '',
        seats: '',
    }),
    components : {
        'v-select' : vSelect,
    },
    mounted() {
        this.initialize();
        if(this.editable !== undefined && !!this.editable) {
            this.populate(this.editable);
        }
    },
    methods: {
        ...mapActions('catalog',['getProductColors']),
        async initialize() {
            try {
                const {data} = await axios.get('/client/modules/upload_car');
                this.years = data.years;
                this.brands = data.brands;
                this.conditions = data.conditions;
            } catch( error) {
                console.error(error);
            }
            this.getProductColors();
        },
        async populate(currentState) {
            this.populating = true;
            this.year_id = currentState.year ? currentState.year : currentState.year_id;
            this.condition_id = parseInt(currentState.condition_id);
            this.kilometers = currentState.kilometers;
            this.exterior_color = currentState.color_id ? currentState.color_id : parseInt(currentState.exterior_color);
            this.interior_color = currentState.interior_color_id ? currentState.interior_color_id : parseInt(currentState.interior_color);
            this.brand_id = parseInt(currentState.brand_id);
        },
        
        async getModels(brand, year) {
            try {
                const {data} = await axios.get(`/client/${year}/brands/${brand}/models`);
                this.models = data;
                this.model_id = '';
                if(this.populating) {
                    this.model_id = parseInt(this.editable.model_id);
                }
            } catch (error) {
                console.error(error);
            }
        },
        async getVersions(brand,year,model) {
            try {
                const {data} = await axios.get(`/client/${year}/brands/${brand}/models/${model}/versions`);
                this.versions = data;
            } catch(error) {
                console.error(error);
            }
                this.version_id = '';
                if(this.populating) {
                    this.version_id = parseInt(this.editable.specs.jato_vehicle_id);
                    this.populating = false;
                }
        },
        submitStep() {
            //TODO :Validation
            const versionTitle = !!this.versions.find(ver => ver.id === this.version_id) ?
                this.versions.find(ver => ver.id === this.version_id).title : '';
            this.$emit('submit',
                this.year_id,
                this.brand_id,
                this.model_id,
                this.version_id,
                versionTitle,
                this.condition_id,
                this.exterior_color,
                this.interior_color,
                this.kilometers,
                this.body_style,
                this.power,
                this.engine,
                this.transmission_type,
                this.fuel_type,
                this.seats
            );
        },
        nextStep() {
            this.submitStep();
            this.$emit('next');
        },
        stepOne() {
            let show = this.step == 1;
            show = !!show && !!this.year_id;
            show = !!show && !!this.brand_id;
            show = !!show && !!this.model_id;
            show = !!show && !!this.condition_id;
            show = !!show && !!this.interior_color;
            show = !!show && !!this.exterior_color;

            return show;
        },
    },
    watch : {
        year_id() {
             if(!this.populating) {
                this.brand_id = '';
            }
        },
        brand_id(newValue) {
            if(newValue !== '') {
                this.getModels(newValue, this.year_id);
            }
            if(!this.populating) {
                this.model_id = '';
            }
        },
        model_id(newValue) {
            if(newValue === '') {
                this.version_id = '';
                return this.versions = [];
            }
            if(newValue !== '') {
                this.getVersions(this.brand_id, this.year_id, newValue);
            }
            if(!this.populating) {
                this.version_id = '';
            }
        },
        version_id(newValue) {
            if(newValue !=='') {
                this.$emit('getSpecs',newValue);
            }else {
                this.$emit('eraseSpecs');
            }
        },
        editable(newValue) {
            if(this.editable !== undefined && !!this.editable) {
                this.populate(this.editable);
            }
        },
        specs(newValue) {
            // Carrocería
            if (newValue['606']) {
                this.body_style = newValue['606'].value;
            }

            //HP
            if (newValue['15304'] && !isNaN(newValue['15304'].value)) {
                this.power = newValue['15304'].value;
            }

            // Engine
            if (newValue['7403'] && newValue['7407'] && newValue['7408']) {
                this.engine = newValue['7403'].value + 'L ' + newValue['7407'].value + ' ' + newValue['7408'].value;
            }

            // Transmission
            if (newValue['20602']) {
                this.transmission_type = newValue['20602'].value;
            }

            // Fuel type
            if (newValue['8702']) {
                this.fuel_type = newValue['8702'].value;
            }

            // Seats number
            if (newValue['702'] && !isNaN(newValue['702'].value)) {
                this.seats = newValue['702'].value;
            }
        },
        formDataChanged() {
            this.submitStep()
        },
    },
    computed : {
        emptySpecs() {
            return _.isEmpty(this.specs);
        },
        formDataChanged () {
            return `${this.brand_id} ${this.year_id} ${this.model_id} ${this.condition_id} ${this.kilometers} ${this.version_id} ${this.exterior_color} ${this.interior_color} `
        },
        ...mapState('catalog',['colors']),
    }
}
</script>
<template>
<div class="box__body">
    <hr>
    <div class="gs:grid">
        <div class="sm:col-3 border-r-grey">
            <!-- YEAR -->
            <div class="form-group pt-6 lg:pt-8 lg:px-4">
                <label class="form-label form-label--big" for="">
                    Año
                </label>
                <v-select
                    :options="years"
                    :class="[err && err['year_id'] ? 'border-red' : '', year_id != '' ? 'input-filled' : '']"
                    class="form-input form-input--big form-input--v-select"
                    name="year_id"
                    id="year_select"
                    :reduce="year => year.year"
                    label="year"
                    v-model="year_id">
                    <span slot="no-options">Sin resultados</span>
                </v-select>
            </div>
        </div>
        <div class="sm:col-13">
            <div class="sm:pt-8 sm:px-4">
                <div class="form-grid">
                    <!-- BRAND -->
                    <div class="form-group sm:col-8">
                        <label class="form-label form-label--big" for="">
                            Marca
                        </label>
                        <v-select
                            placeholder="Seleccionar marca"
                            :reduce="brand => brand.id"
                            label="title"
                            :options="brands"
                            :disabled="year_id == ''"
                            required
                            v-model="brand_id"
                            :class="[err && err['brand_id'] ? 'border-red' : '', brand_id != '' ? 'input-filled' : '' ]"
                            class="form-input form-input--big form-input--v-select"
                            name="brand_id"
                            id="brand_select">
                            <span slot="no-options">Sin resultados</span>
                            <v-icon color="red">edit</v-icon>
                        </v-select>
                    </div>
                    <!-- MODEL -->
                    <div class="form-group sm:col-8">
                        <label class="form-label form-label--big" for="">
                            Modelo
                        </label>
                        <v-select
                            placeholder="Seleccionar modelo"
                            :reduce="model => model.id"
                            label="title"
                            :options="models"
                            :disabled="brand_id == ''"
                            required
                            v-model="model_id"
                            :class="[err && err['model_id'] ? 'border-red' : '', model_id != '' ? 'input-filled' : '']"
                            class="form-input form-input--big form-input--v-select"
                            name="model_id"
                            id="model_selected">
                            <span slot="no-options">Sin resultados</span>
                        </v-select>
                    </div>
                </div>
                <div class="form-grid">
                    <!-- VERSION -->
                    <div class="form-group sm:col-8">
                        <label class="form-label form-label--big" for="">
                            Versión
                        </label>
                        <v-select
                            placeholder="Seleccionar versión"
                            :reduce="version => version.id"
                            label="title"
                            :options="versions"
                            :disabled="model_id == ''"
                            required
                            v-model="version_id"
                            :class="[err && err['version_id'] ? 'border-red' : '', version_id != '' ? 'input-filled' : '']"
                            class="form-input form-input--big form-input--v-select"
                            name="version_id"
                            id="version_selected">
                            <span slot="no-options">Sin resultados</span>
                        </v-select>
                    </div>
                    <!-- CONDITION -->
                    <div class="form-group sm:col-8">
                        <label class="form-label form-label--big" for="">
                            Condición
                        </label>
                        <v-select
                            placeholder="Seleccionar condición"
                            :reduce="condition => condition.id"
                            label="title"
                            :options="conditions"
                            required
                            v-model="condition_id"
                            :class="[err && err['condition_id'] ? 'border-red' : '', condition_id != '' ? 'input-filled' : '']"
                            class="form-input form-input--big form-input--v-select"
                            name="condition_id"
                            id="condition_select">
                            <span slot="no-options">Sin resultados</span>
                        </v-select>
                    </div>
                </div>
                <div class="form-grid">
                    <!-- KMS -->
                    <div class="form-group sm:col-8">
                        <label class="form-label form-label--big" for="">
                            Kilometros
                        </label>
                        <div class="form-inner form-inner--big">
                            <money
                            v-model="kilometers"
                            :class="[err && err['kilometers'] ? 'border-red' : '', kilometers != '' ? 'input-filled' : '']"
                            class="form-input form-input-helper form-input--big"
                            name="kilometers"
                            id="kilometers_input"
                            v-bind="numberFormat"></money>
                            <div class="form-helper tx-12 tx-blue-1">
                                KM
                            </div>
                        </div>
                    </div>
                    <!--  EXTERIOR  COLOR -->
                    <div class="form-group sm:col-4">
                        <label class="form-label form-label--big" for="exterior_color">
                            COLOR EXTERIOR
                        </label>
                        <v-select
                            v-model="exterior_color"
                            :reduce="color => color.id"
                            :options="colors"
                            placeholder="Selecciona color"
                            label="title"
                            :class="[err && err['exterior_color'] ? 'border-red' : '', exterior_color != '' ? 'input-filled' : '']"
                            class="form-input form-input--big"
                            name="colors"
                            id="exterior_color_select" >
                            <span slot="no-options">Sin resultados</span>
                        </v-select>
                    </div>
                    <!--  INTERIOR  COLOR -->
                    <div class="form-group sm:col-4">
                        <label class="form-label form-label--big" for="interior_color_select">
                            COLOR INTERIOR
                        </label>
                        <v-select
                            v-model="interior_color"
                            :reduce="color => color.id"
                            :options="colors"
                            placeholder="Selecciona color"
                            label="title"
                            class="form-input form-input--big"
                            name="colors"
                            id="interior_color_select" >
                            <span slot="no-options">Sin resultados</span>
                        </v-select>
                    </div>
                </div>
                <!-- DATA JATO -->
                <transition name="slide-fade">
                    <div class="form-grid" v-if="editData">
                        <!-- FUEL TYPE -->
                        <div class="form-group sm:col-8">
                            <label class="form-label form-label--big" for="">
                                Tipo de gasolina
                            </label>
                            <div class="form-inner form-inner--big">
                                <input class="form-input form-input--big" type="text" v-model="fuel_type">
                            </div>
                        </div>
                        <!-- HORSEPOWER -->
                        <div class="form-group sm:col-8">
                            <label class="form-label form-label--big" for="">
                                Caballos de fuerza
                            </label>
                            <div class="form-inner form-inner--big">
                                <input class="form-input form-input--big" type="number" v-model="power">
                            </div>
                        </div>
                    </div>
                </transition>
                <div class="gs:grid pt-13 mb-6" v-if="!emptySpecs">
                    <div class="col-8">
                        <table class="table-datasheet tx-14 spacing-0">
                            <tr class="row">
                                <th class="heading w-2/4 tx-left">
                                    <span>
                                        {{specs['606'].name}}
                                    </span>
                                </th>
                                <td class="cell w-2/4 tx-right">
                                    <span class="opacity-70">
                                        {{ body_style }}
                                    </span>
                                </td>
                            </tr>
                            <tr class="row">
                                <th class="heading w-2/4 tx-left">
                                    <span>
                                        Motor
                                    </span>
                                </th>
                                <td class="cell w-2/4 tx-right">
                                    <span class="opacity-70" >
                                        {{ engine }}
                                    </span>
                                </td>
                            </tr>
                            <transition name="fade">
                                <tr class="row" v-if="!editData">
                                    <th class="heading w-2/4 tx-left">
                                        <span>
                                            {{ specs['8702'].name }}
                                        </span>
                                    </th>
                                    <td class="cell w-2/4 tx-right">
                                        <span class="opacity-70">
                                            {{ fuel_type }}
                                        </span>
                                    </td>
                                </tr>
                            </transition>
                        </table>
                    </div>
                    <div class="col-8">
                        <table class="table-datasheet tx-14 spacing-0">
                            <transition name="fade">
                                <tr class="row" v-if="!editData">
                                    <th class="heading w-2/4 tx-left">
                                        <span>
                                            {{ specs['15304'].name }}
                                        </span>
                                    </th>
                                    <td class="cell w-2/4 tx-right">
                                        <span class="opacity-70">
                                            {{ power }}
                                        </span>
                                    </td>
                                </tr>
                            </transition>
                            <tr class="row">
                                <th class="heading w-2/4 tx-left">
                                    <span>
                                        {{specs[ '20602' ].name}}
                                    </span>
                                </th>
                                <td class="cell w-2/4 tx-right">
                                    <span class="opacity-70">
                                        {{ transmission_type }}
                                    </span>
                                </td>
                            </tr>
                            <tr class="row">
                                <th class="heading w-2/4 tx-left">
                                    <span>
                                        {{ specs['702'].name }}
                                    </span>
                                </th>
                                <td class="cell w-2/4 tx-right">
                                    <span class="opacity-70">
                                        {{ seats }}
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="tx-blue-1 tx-14 cursor-pointer w-fit" @click="editData = !editData">
                    <img class="mr-1 mb-1" width="12px" :src=" editData ? '/assets/images/helpers/icon-times-blue.svg' : '/assets/images/helpers/icon-edit-blue.svg'" alt="">
                    <span v-html="editData ? 'Cerrar' : 'Editar'"> </span>
                </div>
            </div>
        </div>
    </div>
    <div v-show="stepOne()" @click="nextStep" class="btn btn--green-ad btn--next weight-500 flex mx-a sm:mr-0 mt-8">
        Continuar
    </div>

</div>
</template>
